import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { FiSend, FiUser } from 'react-icons/fi';
import { FaRobot } from 'react-icons/fa';  // Font Awesome robot icon


const ChatInterface = () => {
  const [messages, setMessages] = useState([
    { sender: 'bot', text: '👋 Hi! Welcome to NRI Local Buddy Support. How can we help you today?' }
  ]);
  const [input, setInput] = useState('');
  const messagesEndRef = useRef(null);

  const handleSend = () => {
    if (!input.trim()) return;

    const userMessage = { sender: 'user', text: input.trim() };
    setMessages(prev => [...prev, userMessage]);
    setInput('');

    // Simulate bot reply for MVP
    setTimeout(() => {
      const botReply = {
        sender: 'bot',
        text: generateBotReply(input.trim())
      };
      setMessages(prev => [...prev, botReply]);
    }, 1000);
  };

  const generateBotReply = (message) => {
    const msg = message.toLowerCase();

    if (msg.includes('payment'))
      return '💳 For payments, please visit your dashboard or contact billing@nrilocalbuddy.com.';
    if (msg.includes('property'))
      return '🏡 You can manage your property in the Property Care section of your dashboard.';
    if (msg.includes('parent'))
      return '👪 We provide dedicated parental care services. Would you like a local caretaker assigned?';
    if (msg.includes('travel'))
      return '✈️ Travel assistance can be scheduled via the Travel Help tab.';
    if (msg.includes('thank'))
      return '😊 Always happy to help! Have a great day!';

    return '🤖 Our agent will reach out to you shortly. Meanwhile, you can call us at +91 9618222498.';
  };

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return (
    <section className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white py-4 sm:py-10 px-2 sm:px-4">
      <div className="max-w-3xl mx-auto w-full bg-white rounded-2xl shadow-lg flex flex-col flex-grow border border-gray-100 min-h-[500px]">
        
        {/* Header */}
        <div className="bg-blue-600 text-white p-3.5 sm:p-4 rounded-t-2xl flex items-center justify-between">
          <h2 className="text-base sm:text-lg font-semibold">NRI Local Buddy Chat Support</h2>
          <span className="text-xs sm:text-sm opacity-90">Online • 24/7</span>
        </div>

        {/* Chat Body */}
        <div className="flex-1 p-3 sm:p-4 overflow-y-auto space-y-4">
          {messages.map((msg, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className={`flex ${msg.sender === 'user' ? 'justify-end' : 'justify-start'}`}
            >
              <div
                className={`flex items-start gap-2 max-w-[88%] sm:max-w-[75%] ${
                  msg.sender === 'user' ? 'flex-row-reverse text-right' : ''
                }`}
              >
                <div
                  className={`p-3 rounded-2xl text-sm ${
                    msg.sender === 'user'
                      ? 'bg-blue-600 text-white rounded-br-none'
                      : 'bg-gray-100 text-gray-800 rounded-bl-none'
                  }`}
                >
                  {msg.text}
                </div>
                <div className="text-gray-400 mt-1">
                  {msg.sender === 'user' ? <FiUser /> : <FaRobot />}
                </div>
              </div>
            </motion.div>
          ))}
          <div ref={messagesEndRef} />
        </div>

        {/* Input Area */}
        <div className="p-4 border-t flex items-center bg-gray-50 rounded-b-2xl">
          <input
            type="text"
            placeholder="Type your message..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleSend()}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
          <button
            onClick={handleSend}
            className="ml-3 bg-blue-600 text-white p-3 rounded-full hover:bg-blue-700 transition"
          >
            <FiSend />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ChatInterface;
